import { createReducer, on } from '@ngrx/store';
import { DevicesApiActions, DeviceSignalRHubActions } from './mdm-devices.actions';
import { adapter, initialState, selectDeviceId } from './mdm-devices.state';

export const mdmDevicesFeatureKey = 'mdm-devices';

export const deviceReducer = createReducer(
  initialState,
  on(DevicesApiActions.devicesLoaded, (state, { devices }) => adapter.upsertMany(devices, state)),
  on(DeviceSignalRHubActions.deviceChanged, (state, { device }) => adapter.upsertOne(device, state)),
  on(DeviceSignalRHubActions.deviceRemoved, (state, { device }) => adapter.removeOne(selectDeviceId(device), state))
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectDeviceIds = selectIds;

export const selectDevicesEntities = selectEntities;

export const selectAllDevices = selectAll;
